namespace Gamification.Gamification {
    export interface UtentiProdottiForm {
        IdUtente: Serenity.IntegerEditor;
        IdProdotto: Serenity.IntegerEditor;
        Classi: Serenity.LookupEditor;
    }

    export class UtentiProdottiForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.UtentiProdotti';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!UtentiProdottiForm.init)  {
                UtentiProdottiForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.LookupEditor;

                Q.initFormType(UtentiProdottiForm, [
                    'IdUtente', w0,
                    'IdProdotto', w0,
                    'Classi', w1
                ]);
            }
        }
    }
}
